import { useFFContext } from '@/components/OpenFeature/hooks/useFFContext';
import { Wrapper } from '@/components/OpenFeature/Wrapper';
import { FinishedProviderSetting } from '@/components/OpenFeature/Wrapper/finishedProviderSetting';
import { OpenFeatureProvider } from '@moneyforward/user-flex-feature-hooks';
import { FC } from 'react';
import { ApprovingInvoiceReports as ApprovingInvoiceReportsList } from './components/List';

export const ApprovingInvoiceReports: FC = () => {
  const ffContext = useFFContext();
  return (
    <Wrapper isProto={false}>
      <OpenFeatureProvider
        pollInterval={-1}
        context={ffContext}
        domain='ap-data-extraction-mismatch-alert'
      >
        <OpenFeatureProvider
          pollInterval={-1}
          context={ffContext}
          domain='ap-data-extraction-mismatch-alert-phase-2'
        >
          <OpenFeatureProvider
            pollInterval={-1}
            context={ffContext}
            domain='ap-keep-approval-search-conditions'
          >
            {/* Mount the list only once the nearest provider has its flags:
                the list reads keep-approval-search-conditions once, on mount,
                to restore the saved search. Same gate as the edit page. */}
            <FinishedProviderSetting>
              <ApprovingInvoiceReportsList />
            </FinishedProviderSetting>
          </OpenFeatureProvider>
        </OpenFeatureProvider>
      </OpenFeatureProvider>
    </Wrapper>
  );
};
